import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onClose: () => void
  isUpgrade?: boolean
}

const ContactModal = ({ onClose, isUpgrade = false }: Props) => {
  const title = isUpgrade ? i18n.t('contact_cx.title') : i18n.t('contact_sales.title')
  const description = isUpgrade
    ? i18n.t('contact_cx.description')
    : i18n.t('contact_sales.description')
  const ctaLabel = i18n.t('contact_cx.cta')

  return (
    <Modal
      illustration="contact-us"
      title={title}
      description={description}
      onClose={onClose}
      footer={<Button onClick={() => onClose()}>{ctaLabel}</Button>}
    />
  )
}

export default ContactModal
